// The version list, the home screen once signed in
const en = {
  settings: 'Settings',
  signOut: 'Sign out',

  title: 'Versions',
  subtitle: "Apps show the newest published version. Edit a draft, then publish it when it's ready.",
  newDraft: 'New draft',
  creatingDraft: 'Creating Draft...',
  fetchError: 'An error occurred while fetching versions',
  noPreviousVersion: 'Cannot create new draft: no previous version found',
  createError: 'Failed to create new version',

  liveInApps: 'Live in apps',
  draftInProgress: 'Draft in progress',
  draft: 'Draft',
  superseded: 'Published · superseded',
  version: (version: number) => `Version ${version}`,
  /** Follows a count in bold, on the version cards */
  artists: (count: number): string => (count === 1 ? 'artist' : 'artists'),
  shows: (count: number): string => (count === 1 ? 'show' : 'shows'),
  stages: (count: number): string => (count === 1 ? 'stage' : 'stages'),
  maps: (count: number): string => (count === 1 ? 'map' : 'maps'),

  allVersions: 'All versions',
  columns: { version: 'Version', name: 'Name', status: 'Status', lastSaved: 'Last saved', content: 'Content' },
  openVersion: (version: number) => `Open version ${version}`,
  rowCounts: (artists: number, shows: number) =>
    `${artists} ${artists === 1 ? 'artist' : 'artists'} · ${shows} ${shows === 1 ? 'show' : 'shows'}`,
  empty: 'No versions found.',

  newDraftTitle: 'New draft',
  internalName: 'Internal name',
  newDraftHint: (from: number, to: number) =>
    `Copies Version ${from} into Version ${to}. The name is only shown in the backoffice. Leave it empty to use the festival name.`,
  createDraft: 'Create draft',
  creating: 'Creating...',
};

const fr: typeof en = {
  settings: 'Paramètres',
  signOut: 'Se déconnecter',

  title: 'Versions',
  subtitle: 'Les apps affichent la dernière version publiée. Modifiez un brouillon, puis publiez-le quand il est prêt.',
  newDraft: 'Nouveau brouillon',
  creatingDraft: 'Création du brouillon...',
  fetchError: 'Une erreur est survenue lors du chargement des versions',
  noPreviousVersion: 'Impossible de créer un brouillon\u00a0: aucune version précédente',
  createError: 'Impossible de créer la nouvelle version',

  liveInApps: 'En ligne dans les apps',
  draftInProgress: 'Brouillon en cours',
  draft: 'Brouillon',
  superseded: 'Publiée · remplacée',
  version: (version: number) => `Version ${version}`,
  artists: (count: number): string => (count > 1 ? 'artistes' : 'artiste'),
  shows: (count: number): string => (count > 1 ? 'shows' : 'show'),
  stages: (count: number): string => (count > 1 ? 'scènes' : 'scène'),
  maps: (count: number): string => (count > 1 ? 'plans' : 'plan'),

  allVersions: 'Toutes les versions',
  columns: { version: 'Version', name: 'Nom', status: 'Statut', lastSaved: 'Enregistrée le', content: 'Contenu' },
  openVersion: (version: number) => `Ouvrir la version ${version}`,
  rowCounts: (artists: number, shows: number) =>
    `${artists} ${artists > 1 ? 'artistes' : 'artiste'} · ${shows} ${shows > 1 ? 'shows' : 'show'}`,
  empty: 'Aucune version.',

  newDraftTitle: 'Nouveau brouillon',
  internalName: 'Nom interne',
  newDraftHint: (from: number, to: number) =>
    `Copie la version ${from} dans la version ${to}. Le nom n'apparaît que dans le back-office. Laissez-le vide pour utiliser le nom du festival.`,
  createDraft: 'Créer le brouillon',
  creating: 'Création...',
};

const messages = { en, fr };
export default messages;
